import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import {Image, Icon, K, Button} from '@henrybuilt/react-lib';
import ScrollableNote from './scrollable-note';

const SortableItem = ({
  id,
  notes,
  notesAreVisible,
  onRemoveMedium,
  onUpdateNotes,
  isPrinting,
  url,
  size = {width: 250, height: 250},
}) => {
  const {
    attributes,
    listeners,
    isDragging,
    setNodeRef,
    transform,
    transition
  } = useSortable({
    id,
    transition: {
      duration: 500, // milliseconds
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    },
  });

  const styles = {
    item: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      userSelect: 'none',
      cursor: 'grab',
      boxSizing: 'border-box',
      transform: CSS.Translate.toString(transform),
      transition,
    },
    image: {
      ...size,
      borderRadius: K.borderRadius - 3,
    },
    wrapper: {
      ...size,
    },
    close: {
      backgroundColor: 'white',
      border: `2px solid ${K.colors.base}`,
      borderColor: K.colors.base,
      borderRadius: 100,
      cursor: 'pointer',
      height: 33,
      width: 33,
      justifyContent: 'center',
      position: 'relative', // applied in order for zIndex to have effect otherrwise when position: static it doesn't have any effect
      zIndex: 2
    },
    note: {
      maxWidth: size.width,
    },
  };

  const DeleteMediumButton = () => {
    return (
      <Button
        key={`image-close-${id}`}
        onClick={onRemoveMedium}
        style={styles.close}
        contentStyle={styles.checkbox}
        data-no-dnd={true}
        icon={
          <Icon
            key={`image-close-${id}`}
            name="close"
          />
        }
      />
    );
  };

  const handleNotesChange = (value) => {
    onUpdateNotes({itemId: id, value});
  };

  const shouldDisplayNotes = notesAreVisible && !(isPrinting && (!notes || notes.length === 0));

  return (
    <div
      style={styles.item}
    >
      <Image
        style={styles.image}
        wrapperStyle={styles.wrapper}
        src={url}
        extra={{topRight: <DeleteMediumButton {...{id}} />}}
        id={id}
        ref={setNodeRef}
        {...attributes}
        {...listeners}
      />
      {shouldDisplayNotes && !isDragging && (<ScrollableNote propNotes={notes} onChange={handleNotesChange} style={styles.note} />)}
    </div>
  );
};

export default SortableItem;
